/**
 * Central dispatcher for UI commands emitted by C'lia (chat-as-command-palette).
 *
 * Backend AiaChatService.detectUiCommand emits SSE `ui_command` events of shape
 * `{ action, params }`. The chat drawer forwards them here; subscribers
 * (the drawer itself for in-drawer dialogs, the shell App.vue for routing,
 * etc.) register a handler per action.
 */
class AiaUiCommandService {

  constructor() {
    this.handlers = new Map();
    this.fallback = null;
  }

  /**
   * Register a handler for an action. Returns an unregister function.
   *   const off = aiaUiCommandService.register('openTicket', ({ key }) => …);
   *   // later: off();
   */
  register(action, handler) {
    if (!action || typeof handler !== 'function') return () => {};
    this.handlers.set(action, handler);
    return () => {
      if (this.handlers.get(action) === handler) this.handlers.delete(action);
    };
  }

  /**
   * Fallback invoked when no handler matches. Typically a toast/notification.
   * Signature: (action, params, reason) => void
   */
  setFallback(fn) {
    this.fallback = typeof fn === 'function' ? fn : null;
  }

  /**
   * Dispatch a command. Called by the drawer when the SSE stream emits
   * a `ui_command` event.
   */
  dispatch({ action, params } = {}) {
    if (!action) return;
    console.log('[CLIA][UI-CMD]', action, params);
    const handler = this.handlers.get(action);
    if (handler) {
      try {
        handler(params || {});
      } catch (e) {
        console.warn('[CLIA][UI-CMD] handler threw:', e?.message || e);
        if (this.fallback) this.fallback(action, params, `handler error: ${e?.message || e}`);
      }
      return;
    }
    if (this.fallback) this.fallback(action, params, 'aucun handler enregistré');
  }
}

export default new AiaUiCommandService();
